import React, { useEffect, useState } from 'react'
import './LeftCampaign.css'
import { useLocation, useNavigate } from 'react-router-dom'

const LeftCampaign = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [show, setShow] = useState(true)

    useEffect(() => {
        setShow(true)
    }, [location.pathname])

    // Academic Year Logic
    const getAcademicYear = () => {
        const today = new Date()

        const currentYear = today.getFullYear()

        // May is month 4 because JS months are 0-indexed
        const changeDate = new Date(currentYear, 4, 1)

        let startYear, endYear

        if (today >= changeDate) {
            startYear = currentYear
            endYear = currentYear + 1
        } else {
            startYear = currentYear - 1
            endYear = currentYear
        }

        return `${startYear}-${String(endYear).slice(-2)}`
    }

      const getNeetYear = () => {
        const today = new Date()
        const currentYear = today.getFullYear()

        // Change on 1st May
        const changeDate = new Date(currentYear, 4, 1)

        return today >= changeDate
            ? currentYear + 1
            : currentYear
    }

    return (
        <>
            {
                show &&
                <div className='left-campaign'>
                    <button
                        className='close'
                        onClick={() => setShow(false)}
                    >
                        &times;
                    </button>

                    <h6 className='text-center text-white mt-4'>
                        NEET {getNeetYear()}
                    </h6>

                    <p
                        className='text-white text-center mt-1'
                        style={{ lineHeight: '15px' }}
                    >
                        Apply for test series
                    </p>

                    <button
                        className='btn btn-success btn-sm d-flex ml-auto mr-auto mt-2'
                        onClick={() => navigate('/register')}
                    >
                        Register Now
                    </button>

                    <div className='acyear'>
                        <span>Academic Year</span>
                        <span>{getAcademicYear()}</span>
                    </div>
                </div>
            }
        </>
    )
}

export default LeftCampaign